module.exports = __webpack_public_path__ + "img/bunny-color.24dbb90f.png";